import {
  PlacementService19zued3tbdmh4 as PlacementService,
  AutoAdaptSessionComponent22ewpf3zhib95 as AutoAdaptSessionComponent,
  get_variantEntities2smv4ibi292bv as get_variantEntities,
  Companion_getInstance1kt5fbscx1wt3 as Companion_getInstance,
  Companion_getInstance12g7fz0zzzhna as Companion_getInstance_0,
  Companion_getInstance1daeu5egcxxhc as Companion_getInstance_1,
  Companion_instance1ywp8gtysici as Companion_instance,
  PlacementResult3tdo3j6xpgae6 as PlacementResult,
  SearchDirectionsUtils_instanceep40lkigythz as SearchDirectionsUtils_instance,
  Companion_getInstance2jl9g5gxyuaw4 as Companion_getInstance_2,
  Companion_getInstance2ylf47lyedbv5 as Companion_getInstance_3,
  recommendedPosition2lbjp2zghgru2 as recommendedPosition,
} from './core-core-stl.mjs';
import {
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  NoSuchElementException_init_$Create$1admdzgt61c19 as NoSuchElementException_init_$Create$,
  ArrayList_init_$Create$2rimpp4x9tjd3 as ArrayList_init_$Create$,
  first1vi3grnpj1175 as first,
  toList383f556t1dixk as toList,
  addAll1k27qatfgp3k5 as addAll,
  copyToArray2j022khrow2yi as copyToArray,
  any3lcolwko9usbz as any,
  ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$_0,
  firstOrNull1gk7vzkf4h3nq as firstOrNull,
  equals2au1ep9vhcato as equals,
  emptyList1g2z5xcrvp2zy as emptyList,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith13ny3qsmk2kn8 as sortedWith,
  listOfvhqybd2zx248 as listOf,
  distinct10qe1scfdvu5k as distinct,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  plus310ted5e4i90h as plus,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString1pkumu07cwy4m as toString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  defineProp3hxgpk2knu2px as defineProp,
} from './kotlin-kotlin-stdlib.mjs';
import {
  RestrictAllowedRequiredHostsComponent1sbq773f5zt75 as RestrictAllowedRequiredHostsComponent,
  Companion_instance3hfkidua2d4d9 as Companion_instance_0,
  get_snapRoot2o0fqu30dlj6i as get_snapRoot,
  get_parentComponent913cs0fasf9z as get_parentComponent,
  get_connectorsComponent2vyt6vnfllddk as get_connectorsComponent,
  Companion_instance11k45hlj7pzgo as Companion_instance_1,
  SnapSettingsu2m0ngibwcj8 as SnapSettings,
  get_worldTransform2y1gcjubsjrt0 as get_worldTransform,
  Companion_instance1f7k6iwukor7l as Companion_instance_2,
  get_hierarchy1sm75rhmsdka0 as get_hierarchy,
  ValidationResultType_FAIL_getInstance3pxpfo6jduhaj as ValidationResultType_FAIL_getInstance,
  get_productRefOrEmptyString34p0nb5m8rrfy as get_productRefOrEmptyString,
  Companion_getInstance1cmxj7l93cwya as Companion_getInstance_4,
  CollisionValidationResultsw0tl1zrikpj as CollisionValidationResult,
  Vector1cgy08ha6e7ya as Vector,
  LoggerState_getInstance458njkt1c1yk as LoggerState_getInstance,
  get_worldRotationjykn4pgiq1i9 as get_worldRotation,
  Transform2e9p9l2euepqa as Transform,
  get_worldPositionwj6kte5ftqpq as get_worldPosition,
  ValidationResultType_WARNING_getInstance3uf8cr4ggrfxr as ValidationResultType_WARNING_getInstance,
} from './core-core-api.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(ExperimentalPlacementService, 'ExperimentalPlacementService', VOID, PlacementService);
initMetadataForClass(LegacyPlacementHelper, 'LegacyPlacementHelper');
initMetadataForCompanion(Companion);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(SnapList, 'SnapList');
initMetadataForClass(SortBuilder, 'SortBuilder', SortBuilder);
initMetadataForInterface(Sorter, 'Sorter');
initMetadataForClass(SorterByDistance, 'SorterByDistance', SorterByDistance, VOID, [Sorter]);
initMetadataForClass(CombinedSorter, 'CombinedSorter', VOID, VOID, [Sorter]);
initMetadataForClass(OriginalSorter, 'OriginalSorter', VOID, VOID, [Sorter]);
initMetadataForClass(PrioritySorter, 'PrioritySorter', VOID, VOID, [Sorter]);
initMetadataForClass(RecommendedDistanceSorter, 'RecommendedDistanceSorter', RecommendedDistanceSorter, VOID, [Sorter]);
initMetadataForClass(WarningsSorter, 'WarningsSorter', WarningsSorter, VOID, [Sorter]);
initMetadataForClass(StartPositioner, 'StartPositioner');
initMetadataForCompanion(Companion_0);
initMetadataForClass(ValidatedSnap, 'ValidatedSnap');
initMetadataForCompanion(Companion_1);
initMetadataForClass(Experimental, 'Experimental', Experimental);
//endregion
function ExperimentalPlacementService(coreServices, autoAdaptService) {
  autoAdaptService = autoAdaptService === VOID ? null : autoAdaptService;
  PlacementService.call(this, coreServices, autoAdaptService);
  this.coreServices = coreServices;
  this.autoAdaptService = autoAdaptService;
}
protoOf(ExperimentalPlacementService).j3t = function () {
  return this.coreServices;
};
protoOf(ExperimentalPlacementService).b5d = function () {
  return this.autoAdaptService;
};
protoOf(ExperimentalPlacementService).i4i = function (entityToPlace, initialPosition, ignoreWarnings, searchDirections, sortAndSelectStrategy) {
  var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
  placementHelper.startPoisitoiner(entityToPlace).orAt(initialPosition).move();
  var sortBuilder = placementHelper.sortBuilder();
  var tmp;
  if (ignoreWarnings) {
    tmp = sortBuilder;
  } else {
    tmp = sortBuilder.sortByWarnings();
  }
  var sortBuilderWithWarnings = tmp;
  var sorter = sortBuilderWithWarnings.sortByOriginalFirst(entityToPlace).sortByPriority(true).sortByDistance().build();
  var snaps = placementHelper.findAllSnapsWithAutoAdapt();
  var validatedSnaps = placementHelper.validateSnaps(snaps);
  var snap = placementHelper.firstValidWhenExtendingSearchOnContinuousConnectors(validatedSnaps, sorter, searchDirections);
  return placementHelper.commitSnap(snap);
};
protoOf(ExperimentalPlacementService).j4i = function (entityToPlace, closeTo, searchDirections, sortAndSelectStrategy) {
  var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
  placementHelper.startPoisitoiner(entityToPlace).atRecommendedPosition().orAt(closeTo).move();
  var sortBuilder = placementHelper.sortBuilder();
  var sorter = sortBuilder.sortByWarnings().sortByOriginalFirst(entityToPlace).sortByPriority(false).sortByRecommendedDistance().sortByDistance().build();
  var snaps = placementHelper.findAllSnapsWithAutoAdapt();
  var validatedSnaps = placementHelper.validateSnaps(snaps);
  var snap = placementHelper.firstValidWhenExtendingSearchOnContinuousConnectors(validatedSnaps, sorter, searchDirections);
  return placementHelper.commitSnap(snap);
};
protoOf(ExperimentalPlacementService).k4i = function (entityToPlace, target, sortAndSelectStrategy) {
  var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
  placementHelper.startPoisitoiner(entityToPlace).atRecommendedPosition().move();
  var sortBuilder = placementHelper.sortBuilder();
  var sorter = sortBuilder.sortByWarnings().sortByOriginalFirst(entityToPlace).sortByPriority(false).sortByRecommendedDistance().sortByDistance().build();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [target];
  var snaps = placementHelper.finaAllSnapsToWithAutoAdapt(tmp$ret$2);
  var validatedSnaps = placementHelper.validateSnaps(snaps);
  var snap = placementHelper.firstValidWhenExtendingSearchOnContinuousConnectors(validatedSnaps, sorter);
  return placementHelper.commitSnap(snap);
};
protoOf(ExperimentalPlacementService).l4i = function (entityToPlace, targets, sortAndSelectStrategy) {
  var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
  placementHelper.startPoisitoiner(entityToPlace).atRecommendedPosition().move();
  var sortBuilder = placementHelper.sortBuilder();
  var sorter = sortBuilder.sortByWarnings().sortByOriginalFirst(entityToPlace).sortByPriority(false).sortByRecommendedDistance().sortByDistance().build();
  entityToPlace.addComponent(new RestrictAllowedRequiredHostsComponent(targets));
  var snaps = placementHelper.finaAllSnapsToWithAutoAdapt(targets);
  var validatedSnaps = placementHelper.validateSnaps(snaps);
  var snap = placementHelper.firstValidWhenExtendingSearchOnContinuousConnectors(validatedSnaps, sorter);
  var result = placementHelper.commitSnap(snap);
  entityToPlace.removeComponent(Companion_instance_0.id);
  var tmp0_safe_receiver = result.placedEntity;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.removeComponent(Companion_instance_0.id);
  return result;
};
protoOf(ExperimentalPlacementService).n4i = function (entityToPlace, target, sortAndSelectStrategy) {
  var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
  placementHelper.startPoisitoiner(entityToPlace).atRecommendedPosition().move();
  var sortBuilder = placementHelper.sortBuilder();
  var sorter = sortBuilder.sortByWarnings().sortByOriginalFirst(entityToPlace).sortByPriority(false).sortByRecommendedDistance().sortByDistance().build();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [target];
  var snaps = placementHelper.finaAllSnapsToWithAutoAdapt(tmp$ret$2);
  var validatedSnaps = placementHelper.validateSnaps(snaps);
  var snap = placementHelper.firstValid(validatedSnaps, sorter);
  return placementHelper.forceCommitSnap(snap);
};
function findSnaps($this, hosts) {
  var tmp0_elvis_lhs = get_snapRoot($this.entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = get_parentComponent($this.entity);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.children;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.first' call
        var inductionVariable = 0;
        var last = tmp2_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp2_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.findSnaps.<anonymous>' call
          if (!(get_connectorsComponent(element) == null)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        throw NoSuchElementException_init_$Create$('Array contains no element matching the predicate.');
      }
      tmp_0 = tmp$ret$1;
    }
    var tmp3_safe_receiver = tmp_0;
    tmp = tmp3_safe_receiver == null ? null : get_snapRoot(tmp3_safe_receiver);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp4_elvis_lhs = tmp;
  var snappingEntity = tmp4_elvis_lhs == null ? $this.entity : tmp4_elvis_lhs;
  snappingEntity.addComponent(new AutoAdaptSessionComponent());
  moveVariantsToEntityPosition($this, snappingEntity);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = get_variantEntities(snappingEntity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_0.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = this_0[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.findSnaps.<anonymous>' call
    var tmp_1;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_2;
    if (hosts == null) {
      tmp_2 = true;
    } else {
      // Inline function 'kotlin.collections.isEmpty' call
      tmp_2 = hosts.length === 0;
    }
    if (tmp_2) {
      tmp_1 = Companion_instance_1.i3e(element_0, $this.sceneManager, new SnapSettings(true, VOID, VOID, true));
    } else {
      if (hosts.length > 1) {
        tmp_1 = Companion_instance_1.p39(element_0, hosts, new SnapSettings(true, VOID, VOID, true));
      } else {
        tmp_1 = Companion_instance_1.p1l(element_0, first(hosts), new SnapSettings(true, VOID, true, true));
      }
    }
    var snapsForGuest = tmp_1;
    var list = toList(snapsForGuest);
    addAll(destination, list);
  }
  var snaps = destination;
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(snaps);
}
function moveVariantsToEntityPosition($this, entity) {
  var originalTransform = get_worldTransform(entity);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_variantEntities(entity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.moveVariantsToEntityPosition.<anonymous>' call
    Companion_instance_2.z1l(element, originalTransform);
  }
}
function LegacyPlacementHelper(entity, coreServices) {
  this.entity = entity;
  this.coreServices = coreServices;
  this.entityManager = this.coreServices.entityManager;
  this.sceneManager = this.coreServices.sceneManager;
  this.productManager = this.coreServices.productManager;
  var tmp = this;
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  tmp.c5d_1 = new SnapList(this.entity, tmp$ret$0, this.coreServices);
}
protoOf(LegacyPlacementHelper).v2i = function () {
  return this.entity;
};
protoOf(LegacyPlacementHelper).j3t = function () {
  return this.coreServices;
};
protoOf(LegacyPlacementHelper).c1k = function () {
  return this.entityManager;
};
protoOf(LegacyPlacementHelper).d1k = function () {
  return this.sceneManager;
};
protoOf(LegacyPlacementHelper).i1k = function () {
  return this.productManager;
};
protoOf(LegacyPlacementHelper).startPoisitoiner = function (entityToPlace) {
  return new StartPositioner(entityToPlace, this.entityManager);
};
protoOf(LegacyPlacementHelper).findAllSnapsWithAutoAdapt = function () {
  var canAutoAdapt = this.entity.hasComponent(Companion_getInstance().id);
  var tmp;
  if (canAutoAdapt) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_hierarchy(this.sceneManager.root);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.findAllSnapsWithAutoAdapt.<anonymous>' call
      if (element.hasComponent(Companion_getInstance_0().id)) {
        destination.h(element);
      }
    }
    tmp = destination;
  } else {
    tmp = null;
  }
  var hosts = tmp;
  var tmp_0;
  if (hosts == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(hosts);
  }
  return findSnaps(this, tmp_0);
};
protoOf(LegacyPlacementHelper).finaAllSnapsToWithAutoAdapt = function (targets) {
  return findSnaps(this, targets);
};
protoOf(LegacyPlacementHelper).commitSnap = function (validatedSnap) {
  var tmp;
  if ((validatedSnap == null ? null : validatedSnap.isValid) === true) {
    tmp = validatedSnap.snap;
  } else {
    tmp = null;
  }
  var snap = tmp;
  var tmp2_elvis_lhs = validatedSnap == null ? null : validatedSnap.result;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_0 = [];
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var results = tmp_0;
  if (snap == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    snap.performMoveAndConnect();
    snap.guestRoot.removeComponent(Companion_getInstance_1().ID);
    var tmp_1;
    if (any(results)) {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$1 = [];
      tmp_1 = new PlacementResult(results, tmp$ret$1, snap.guestRoot);
    } else {
      tmp_1 = Companion_instance.z4h(snap.guestRoot);
    }
    return tmp_1;
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = results.length;
  while (inductionVariable < last) {
    var element = results[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.commitSnap.<anonymous>' call
    if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
      destination.h(element);
    }
  }
  var errors = copyToArray(destination);
  this.entity.removeComponent(Companion_getInstance_1().ID);
  var tmp_2;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(errors.length === 0)) {
    tmp_2 = Companion_instance.b4i(errors);
  } else {
    tmp_2 = Companion_instance.failWithMessage$default('No snap found', get_productRefOrEmptyString(this.entity));
  }
  return tmp_2;
};
protoOf(LegacyPlacementHelper).forceCommitSnap = function (validatedSnap) {
  var tmp1_safe_receiver = validatedSnap == null ? null : validatedSnap.snap;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    tmp1_safe_receiver.performMoveAndConnect();
    return Companion_instance.z4h(this.entity);
  }
  return Companion_instance.failWithMessage$default('No possible snapActions in target', get_productRefOrEmptyString(this.entity));
};
protoOf(LegacyPlacementHelper).sortBuilder = function () {
  return new SortBuilder();
};
protoOf(LegacyPlacementHelper).validateSnaps = function (snaps) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(snaps.length);
  var inductionVariable = 0;
  var last = snaps.length;
  while (inductionVariable < last) {
    var item = snaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.validateSnaps.<anonymous>' call
    var result = this.coreServices.validations.validateSnapCandidate(item);
    var tmp$ret$0 = Companion_instance_4.fromValidateSnapCandidate(result);
    destination.h(tmp$ret$0);
  }
  return copyToArray(destination);
};
protoOf(LegacyPlacementHelper).d5d = function (validatedSnaps, sorter, searchDirections) {
  return this.c5d_1.d5d(validatedSnaps, sorter, searchDirections);
};
protoOf(LegacyPlacementHelper).firstValidWhenExtendingSearchOnContinuousConnectors = function (validatedSnaps, sorter, searchDirections, $super) {
  var tmp;
  if (searchDirections === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [Companion_getInstance_4().LEFT, Companion_getInstance_4().RIGHT, Companion_getInstance_4().UP, Companion_getInstance_4().DOWN, Companion_getInstance_4().BACK, Companion_getInstance_4().FORWARD];
  } else {
    tmp = searchDirections;
  }
  searchDirections = tmp;
  return this.d5d(validatedSnaps, sorter, searchDirections);
};
protoOf(LegacyPlacementHelper).firstValid = function (validatedSnaps, sorter) {
  return this.c5d_1.firstValid(validatedSnaps, sorter);
};
function best($this, candidate, bestSoFar, sorter) {
  if (!candidate.isValid)
    return bestSoFar;
  if (bestSoFar == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return sorter.aaa(bestSoFar, candidate);
  }
  return candidate;
}
function validate($this, candidate, validationService) {
  var candidateResult = Companion_instance_4.fromValidateSnapCandidate(validationService.validateSnapCandidate(candidate));
  return candidateResult;
}
function getAlignmentCandidatesThatResolvesCollision($this, candidates, failedCandidateResult) {
  var tmp0_safe_receiver = failedCandidateResult.result;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.getAlignmentCandidatesThatResolvesCollision.<anonymous>' call
      if (element instanceof CollisionValidationResult) {
        var tmp0_safe_receiver_0 = firstOrNull(element.collisions);
        var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.other;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList_init_$Create$();
          var tmp0_iterator = candidates.k();
          while (tmp0_iterator.m()) {
            var element_0 = tmp0_iterator.n();
            // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.getAlignmentCandidatesThatResolvesCollision.<anonymous>.<anonymous>.<anonymous>' call
            var tmp;
            var tmp0_safe_receiver_1 = element_0.snap.alignmentInitiatorCandidate;
            if (equals(tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.host, tmp1_safe_receiver)) {
              tmp = element_0.isValid;
            } else {
              tmp = false;
            }
            if (tmp) {
              destination.h(element_0);
            }
          }
          return destination;
        }
      }
    }
  }
  return emptyList();
}
function findNewPositionThatMightSatisfyFailedResult($this, failed, entityToAdd, searchDirections, level) {
  var tmp0_safe_receiver = failed.result;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findNewPositionThatMightSatisfyFailedResult.<anonymous>' call
      var tmp_0;
      if (element instanceof CollisionValidationResult) {
        tmp_0 = SearchDirectionsUtils_instance.f4j(entityToAdd, failed.snap, element, searchDirections, level === 0);
      } else {
        tmp_0 = emptyList();
      }
      var list = tmp_0;
      addAll(destination, list);
    }
    tmp = destination;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
function Companion() {
  this.j5d_1 = 5;
}
var Companion_instance_3;
function Companion_getInstance_5() {
  return Companion_instance_3;
}
function sam$kotlin_Comparator$0(function_0) {
  this.k5d_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).md = function (a, b) {
  return this.k5d_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0).s3 = function () {
  return this.k5d_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.s3());
};
function SnapList$sortByDistance$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.sortByDistance.<anonymous>' call
  var tmp = a.snap.movement.size;
  // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.sortByDistance.<anonymous>' call
  var tmp$ret$1 = b.snap.movement.size;
  return compareValues(tmp, tmp$ret$1);
}
function SnapList(entity, snaps, coreServices) {
  this.e5d_1 = entity;
  this.f5d_1 = snaps;
  this.g5d_1 = coreServices;
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.f5d_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.validatedSnaps.<anonymous>' call
    var tmp$ret$0 = new ValidatedSnap(item, null);
    destination.h(tmp$ret$0);
  }
  tmp.h5d_1 = copyToArray(destination);
  this.i5d_1 = this.g5d_1.validations;
}
protoOf(SnapList).sortByDistance = function () {
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = this.h5d_1;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = SnapList$sortByDistance$lambda;
  var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_0);
  var this_1 = sortedWith(this_0, tmp$ret$0);
  tmp.h5d_1 = copyToArray(this_1);
};
protoOf(SnapList).validateAll = function () {
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = this.h5d_1;
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.validateAll.<anonymous>' call
    var snap = element.tf();
    var result = this.g5d_1.validations.validateSnapCandidate(snap);
    var tmp0_safe_receiver = Companion_instance_4.fromValidateSnapCandidate(result);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  tmp.h5d_1 = copyToArray(destination);
};
protoOf(SnapList).firstValid = function (validatedSnaps, sorter) {
  var bestSoFar = null;
  var inductionVariable = 0;
  var last = validatedSnaps.length;
  while (inductionVariable < last) {
    var cr = validatedSnaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (cr.isValid) {
      bestSoFar = best(this, cr, bestSoFar, sorter);
    }
  }
  var tmp;
  if (!(bestSoFar == null)) {
    tmp = bestSoFar;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = validatedSnaps.length;
    while (inductionVariable_0 < last_0) {
      var element = validatedSnaps[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.firstValid.<anonymous>' call
      var tmp0_safe_receiver = element.result;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toList(tmp0_safe_receiver);
      var list = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
      addAll(destination, list);
    }
    var allResults = copyToArray(destination);
    var tmp0_safe_receiver_0 = firstOrNull(validatedSnaps);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.copy(VOID, allResults);
  }
  return tmp;
};
protoOf(SnapList).d5d = function (validatedSnaps, sorter, searchDirections) {
  var bestSoFar = null;
  var inductionVariable = 0;
  var last = validatedSnaps.length;
  while (inductionVariable < last) {
    var cr = validatedSnaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (cr.isValid) {
      bestSoFar = best(this, cr, bestSoFar, sorter);
    } else if (cr.snap.hostConnector.isContinuousConnector && cr.snap.alignmentInitiatorCandidate == null) {
      bestSoFar = this.findBestValidPositionOnConnector(toList(validatedSnaps), bestSoFar, listOf(cr), this.e5d_1, cr.snap, searchDirections, this.i5d_1, sorter);
    }
  }
  var tmp;
  if (!(bestSoFar == null)) {
    tmp = bestSoFar;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = validatedSnaps.length;
    while (inductionVariable_0 < last_0) {
      var element = validatedSnaps[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.firstValidWhenExtendingSearchOnContinuousConnectors.<anonymous>' call
      var tmp0_safe_receiver = element.result;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toList(tmp0_safe_receiver);
      var list = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
      addAll(destination, list);
    }
    var allResults = copyToArray(destination);
    var tmp0_safe_receiver_0 = firstOrNull(validatedSnaps);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.copy(VOID, allResults);
  }
  return tmp;
};
protoOf(SnapList).firstValidWhenExtendingSearchOnContinuousConnectors = function (validatedSnaps, sorter, searchDirections, $super) {
  var tmp;
  if (searchDirections === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [Companion_getInstance_4().LEFT, Companion_getInstance_4().RIGHT, Companion_getInstance_4().UP, Companion_getInstance_4().DOWN, Companion_getInstance_4().BACK, Companion_getInstance_4().FORWARD];
  } else {
    tmp = searchDirections;
  }
  searchDirections = tmp;
  return $super === VOID ? this.d5d(validatedSnaps, sorter, searchDirections) : $super.d5d.call(this, validatedSnaps, sorter, searchDirections);
};
protoOf(SnapList).l5d = function (validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sorter, triedPositions, level) {
  if (level >= Companion_instance_3.j5d_1) {
    return bestSoFar;
  }
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = failed.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
    var list = getAlignmentCandidatesThatResolvesCollision(this, validatedCandidates, element);
    addAll(destination, list);
  }
  var validAlignments = destination;
  var localBest = null;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = validAlignments.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
    localBest = best(this, element_0, localBest, sorter);
  }
  var tmp0_safe_receiver = localBest;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return best(this, tmp0_safe_receiver, bestSoFar, sorter);
  }
  var initialTransform = get_worldTransform(entityToAdd);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator_1 = failed.k();
  while (tmp0_iterator_1.m()) {
    var element_1 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
    var list_0 = findNewPositionThatMightSatisfyFailedResult(this, element_1, entityToAdd, searchDirections, level);
    addAll(destination_0, list_0);
  }
  // Inline function 'kotlin.collections.filterNotTo' call
  var this_0 = distinct(destination_0);
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_2 = this_0.k();
  while (tmp0_iterator_2.m()) {
    var element_2 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
    if (!triedPositions.s(element_2)) {
      destination_1.h(element_2);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$();
  var tmp0_iterator_3 = destination_1.k();
  while (tmp0_iterator_3.m()) {
    var element_3 = tmp0_iterator_3.n();
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
    if (bestSoFar == null || initialTransform.position.distanceTo(element_3) < bestSoFar.snap.movement.size) {
      destination_2.h(element_3);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_3 = ArrayList_init_$Create$();
  var tmp0_iterator_4 = destination_2.k();
  while (tmp0_iterator_4.m()) {
    var element_4 = tmp0_iterator_4.n();
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
    if (Companion_instance_1.isNewPositionOnHostConnector(candidate, element_4)) {
      destination_3.h(element_4);
    }
  }
  var newPositions = destination_3;
  if (newPositions.r() && !(bestSoFar == null)) {
    return bestSoFar;
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(newPositions, 10));
  var tmp0_iterator_5 = newPositions.k();
  while (tmp0_iterator_5.m()) {
    var item = tmp0_iterator_5.n();
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
    var newCandidate = Companion_instance_1.createCandidate(candidate.guest, candidate.guestConnector, candidate.host, candidate.hostConnector, candidate.endTransform.copy(item), VOID, VOID, initialTransform);
    var tmp$ret$16 = validate(this, newCandidate, validationService);
    destination_4.h(tmp$ret$16);
  }
  var newResults = destination_4;
  localBest = null;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_5 = ArrayList_init_$Create$();
  var tmp0_iterator_6 = newResults.k();
  while (tmp0_iterator_6.m()) {
    var element_5 = tmp0_iterator_6.n();
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
    if (element_5.isValid) {
      destination_5.h(element_5);
    }
  }
  var tmp0_iterator_7 = destination_5.k();
  while (tmp0_iterator_7.m()) {
    var element_6 = tmp0_iterator_7.n();
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
    localBest = best(this, element_6, localBest, sorter);
  }
  var tmp1_safe_receiver = localBest;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    return best(this, tmp1_safe_receiver, bestSoFar, sorter);
  }
  return this.l5d(validatedCandidates, bestSoFar, newResults, entityToAdd, candidate, searchDirections, validationService, sorter, plus(triedPositions, newPositions), level + 1 | 0);
};
protoOf(SnapList).findBestValidPositionOnConnector = function (validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sorter, triedPositions, level, $super) {
  triedPositions = triedPositions === VOID ? emptyList() : triedPositions;
  level = level === VOID ? 0 : level;
  return $super === VOID ? this.l5d(validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sorter, triedPositions, level) : $super.l5d.call(this, validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sorter, triedPositions, level);
};
function get_logger() {
  _init_properties_SortBuilder_kt__dwrk6j();
  return logger;
}
var logger;
function SortBuilder() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.m5d_1 = ArrayList_init_$Create$();
}
protoOf(SortBuilder).sortByDistance = function () {
  this.m5d_1.h(new SorterByDistance());
  return this;
};
protoOf(SortBuilder).build = function () {
  return new CombinedSorter(this.m5d_1);
};
protoOf(SortBuilder).sortByOriginalFirst = function (entityToPlace) {
  this.m5d_1.h(new OriginalSorter(entityToPlace));
  return this;
};
protoOf(SortBuilder).sortByPriority = function (onlyInActivationDistance) {
  this.m5d_1.h(new PrioritySorter(onlyInActivationDistance));
  return this;
};
protoOf(SortBuilder).sortByRecommendedDistance = function () {
  this.m5d_1.h(new RecommendedDistanceSorter());
  return this;
};
protoOf(SortBuilder).sortByWarnings = function () {
  this.m5d_1.h(new WarningsSorter());
  return this;
};
function Sorter() {
}
function SorterByDistance() {
}
protoOf(SorterByDistance).aaa = function (a, b) {
  var tmp;
  if (a.snap.movement.size < b.snap.movement.size) {
    tmp = a;
  } else if (a.snap.movement.size > b.snap.movement.size) {
    tmp = b;
  } else {
    tmp = null;
  }
  return tmp;
};
function CombinedSorter(sorters) {
  this.n5d_1 = sorters;
}
protoOf(CombinedSorter).aaa = function (a, b) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
    var tmp0_iterator = this.n5d_1.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.CombinedSorter.sort.<anonymous>' call
      var result = element.aaa(a, b);
      if (!(result == null)) {
        tmp$ret$1 = result;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var best = tmp$ret$1;
  return best == null ? a : best;
};
function OriginalSorter(originalEntity) {
  this.o5d_1 = originalEntity;
}
protoOf(OriginalSorter).aaa = function (a, b) {
  var aIsOriginal = a.snap.guestRoot.equals(this.o5d_1);
  var bIsOriginal = b.snap.guestRoot.equals(this.o5d_1);
  var tmp;
  if (aIsOriginal && bIsOriginal) {
    tmp = null;
  } else if (aIsOriginal) {
    tmp = a;
  } else {
    tmp = b;
  }
  return tmp;
};
function PrioritySorter(onlyInActivationDistance) {
  this.p5d_1 = onlyInActivationDistance;
}
protoOf(PrioritySorter).aaa = function (a, b) {
  var tmp;
  if (a.snap.inActivationDistance() || !this.p5d_1) {
    tmp = a.snap.priority;
  } else {
    tmp = -2147483648;
  }
  var aPrio = tmp;
  var tmp_0;
  if (b.snap.inActivationDistance() || !this.p5d_1) {
    tmp_0 = b.snap.priority;
  } else {
    tmp_0 = -2147483648;
  }
  var bPrio = tmp_0;
  var tmp_1;
  if (aPrio > bPrio) {
    tmp_1 = a;
  } else if (aPrio < bPrio) {
    tmp_1 = b;
  } else {
    tmp_1 = null;
  }
  return tmp_1;
};
function recommendationDistance($this, candidate) {
  var result = Companion_getInstance_4().ZERO;
  var tmp0_safe_receiver = candidate.guestRoot.__getComponentForKotlin(Companion_getInstance_2().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = tmp0_safe_receiver.offsetY - candidate.endTransform.position.Y;
    var diff = Math.abs(this_0);
    result = new Vector(0.0, diff, 0.0);
  }
  if (candidate.guestRoot.__getComponentForKotlin(Companion_getInstance_3().id) == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp = get_logger();
    tmp.warn(RecommendedDistanceSorter$recommendationDistance$lambda);
  }
  return result;
}
function RecommendedDistanceSorter$recommendationDistance$lambda() {
  return 'PositionFromParent is not yet implemented';
}
function RecommendedDistanceSorter() {
}
protoOf(RecommendedDistanceSorter).aaa = function (a, b) {
  var aDist = recommendationDistance(this, a.snap).size;
  var bDist = recommendationDistance(this, b.snap).size;
  var tmp;
  if (aDist < bDist) {
    tmp = a;
  } else if (aDist > bDist) {
    tmp = b;
  } else {
    tmp = null;
  }
  return tmp;
};
function WarningsSorter() {
}
protoOf(WarningsSorter).aaa = function (a, b) {
  var aWarnings = a.countWarnings();
  var bWarnings = b.countWarnings();
  var tmp;
  if (aWarnings > bWarnings) {
    tmp = b;
  } else if (aWarnings < bWarnings) {
    tmp = a;
  } else {
    tmp = null;
  }
  return tmp;
};
var properties_initialized_SortBuilder_kt_lj95wt;
function _init_properties_SortBuilder_kt__dwrk6j() {
  if (!properties_initialized_SortBuilder_kt_lj95wt) {
    properties_initialized_SortBuilder_kt_lj95wt = true;
    logger = LoggerState_getInstance().g1v('RecommendedDistanceSorter');
  }
}
function StartPositioner(entity, entityManager) {
  this.entity = entity;
  this.entityManager = entityManager;
  this.q5d_1 = false;
}
protoOf(StartPositioner).v2i = function () {
  return this.entity;
};
protoOf(StartPositioner).c1k = function () {
  return this.entityManager;
};
protoOf(StartPositioner).at = function (vector) {
  if (vector == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    Companion_instance_2.z1l(this.entity, new Transform(vector, get_worldRotation(this.entity)));
    this.q5d_1 = true;
  }
  return this;
};
protoOf(StartPositioner).atRecommendedPosition = function () {
  var tmp0_safe_receiver = recommendedPosition(this.entity, get_worldPosition(this.entity));
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    Companion_instance_2.z1l(this.entity, new Transform(tmp0_safe_receiver, get_worldRotation(this.entity)));
    this.q5d_1 = true;
  }
  return this;
};
protoOf(StartPositioner).orAtRecommendedPosition = function () {
  if (!this.q5d_1) {
    this.atRecommendedPosition();
  }
  return this;
};
protoOf(StartPositioner).orAt = function (vector) {
  if (!this.q5d_1) {
    if (vector == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.experimental.placement.twopointo.StartPositioner.orAt.<anonymous>' call
      this.at(vector);
    }
  }
  return this;
};
protoOf(StartPositioner).move = function () {
};
function Companion_0() {
}
protoOf(Companion_0).fromValidateSnapCandidate = function (snapValidationResult) {
  return new ValidatedSnap(snapValidationResult.snap, snapValidationResult.errorsAndWarnings);
};
var Companion_instance_4;
function Companion_getInstance_6() {
  return Companion_instance_4;
}
function ValidatedSnap(snap, result) {
  result = result === VOID ? null : result;
  this.snap = snap;
  this.result = result;
  var tmp = this;
  var tmp0_safe_receiver = this.result;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.none' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.experimental.placement.twopointo.ValidatedSnap.isValid.<anonymous>' call
        if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    tmp_0 = tmp$ret$1;
  }
  var tmp1_elvis_lhs = tmp_0;
  tmp.isValid = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
}
protoOf(ValidatedSnap).t1u = function () {
  return this.snap;
};
protoOf(ValidatedSnap).r5d = function (_set____db54di) {
  this.result = _set____db54di;
};
protoOf(ValidatedSnap).s5d = function () {
  return this.result;
};
protoOf(ValidatedSnap).t5d = function () {
  return this.isValid;
};
protoOf(ValidatedSnap).u5d = function () {
  return !(this.result == null);
};
protoOf(ValidatedSnap).countWarnings = function () {
  var tmp0_safe_receiver = this.result;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.count' call
    var count = 0;
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.ValidatedSnap.countWarnings.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_WARNING_getInstance())) {
        count = count + 1 | 0;
      }
    }
    tmp = count;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
};
protoOf(ValidatedSnap).tf = function () {
  return this.snap;
};
protoOf(ValidatedSnap).uf = function () {
  return this.result;
};
protoOf(ValidatedSnap).v5d = function (snap, result) {
  return new ValidatedSnap(snap, result);
};
protoOf(ValidatedSnap).copy = function (snap, result, $super) {
  snap = snap === VOID ? this.snap : snap;
  result = result === VOID ? this.result : result;
  return this.v5d(snap, result);
};
protoOf(ValidatedSnap).toString = function () {
  return 'ValidatedSnap(snap=' + this.snap.toString() + ', result=' + toString(this.result) + ')';
};
protoOf(ValidatedSnap).hashCode = function () {
  var result = hashCode(this.snap);
  result = imul(result, 31) + (this.result == null ? 0 : hashCode(this.result)) | 0;
  return result;
};
protoOf(ValidatedSnap).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ValidatedSnap))
    return false;
  var tmp0_other_with_cast = other instanceof ValidatedSnap ? other : THROW_CCE();
  if (!equals(this.snap, tmp0_other_with_cast.snap))
    return false;
  if (!equals(this.result, tmp0_other_with_cast.result))
    return false;
  return true;
};
function ExperimentalPlacementService$_init_$ref_61iroz() {
  var l = function (p0, p1) {
    return new ExperimentalPlacementService(p0, p1);
  };
  l.callableName = '<init>';
  return l;
}
function LegacyPlacementHelper$_init_$ref_nbi9hh() {
  var l = function (p0, p1) {
    return new LegacyPlacementHelper(p0, p1);
  };
  l.callableName = '<init>';
  return l;
}
function ValidatedSnap$_init_$ref_b5n0rx() {
  var l = function (p0, p1) {
    return new ValidatedSnap(p0, p1);
  };
  l.callableName = '<init>';
  return l;
}
function Companion_1() {
  Companion_instance_5 = this;
  var tmp = this;
  tmp.ExperimentalPlacementService = ExperimentalPlacementService$_init_$ref_61iroz();
  var tmp_0 = this;
  tmp_0.LegacyPlacementHelper = LegacyPlacementHelper$_init_$ref_nbi9hh();
  var tmp_1 = this;
  tmp_1.ValidatedSnap = ValidatedSnap$_init_$ref_b5n0rx();
}
protoOf(Companion_1).w5d = function () {
  return this.ExperimentalPlacementService;
};
protoOf(Companion_1).x5d = function () {
  return this.LegacyPlacementHelper;
};
protoOf(Companion_1).y5d = function () {
  return this.ValidatedSnap;
};
var Companion_instance_5;
function Companion_getInstance_7() {
  if (Companion_instance_5 == null)
    new Companion_1();
  return Companion_instance_5;
}
function get_ExperimentalPlacementService() {
  return Companion_getInstance_7().ExperimentalPlacementService;
}
function get_LegacyPlacementHelper() {
  return Companion_getInstance_7().LegacyPlacementHelper;
}
function get_ValidatedSnap() {
  return Companion_getInstance_7().ValidatedSnap;
}
function Experimental() {
  Companion_getInstance_7();
}
//region block: post-declaration
defineProp(protoOf(ValidatedSnap), 'isValidated', protoOf(ValidatedSnap).u5d);
//endregion
//region block: init
Companion_instance_3 = new Companion();
Companion_instance_4 = new Companion_0();
//endregion
//region block: exports
defineProp(ValidatedSnap, 'Companion', Companion_getInstance_6);
defineProp(Experimental, 'ExperimentalPlacementService', get_ExperimentalPlacementService);
defineProp(Experimental, 'LegacyPlacementHelper', get_LegacyPlacementHelper);
defineProp(Experimental, 'ValidatedSnap', get_ValidatedSnap);
defineProp(Experimental, 'Companion', Companion_getInstance_7);
export {
  ExperimentalPlacementService as ExperimentalPlacementService,
  LegacyPlacementHelper as LegacyPlacementHelper,
  SortBuilder as SortBuilder,
  StartPositioner as StartPositioner,
  ValidatedSnap as ValidatedSnap,
  Experimental as Experimental,
};
//endregion

//# sourceMappingURL=core-core-experimental.mjs.map
